import { useToast } from '@chakra-ui/react';
import { useState } from 'react';

import { trpc } from '../../config/trpc';

/**
 * Opens a document's signed download URL in a new tab. `downloadingId` tracks which document is in flight so lists can
 * spinner just the clicked row.
 */
export const useDownloadDocument = () => {
  const toast = useToast({ position: 'bottom', duration: 4000 });
  const { mutateAsync: downloadDocument } = trpc.downloadDocument.useMutation();
  const [downloadingId, setDownloadingId] = useState<number | null>(null);

  const download = async (id: number) => {
    setDownloadingId(id);
    try {
      const { signedUrl } = await downloadDocument({ id });
      window.open(signedUrl, '_blank');
    } catch (error: any) {
      toast({ title: 'Error', description: error?.message, status: 'error' });
    } finally {
      setDownloadingId(null);
    }
  };

  return { download, downloadingId, isDownloading: downloadingId !== null };
};
